import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PosProfileFormWrapperComponent } from '../components/pos-profile-form-wrapper/pos-profile-form-wrapper.component';
import { 
  PosProfileFormConfig,
  getPosProfileFormConfig
} from '../pos-profile.config';
import { PosProfileService } from '../services/pos-profile.service';

@Component({
  selector: 'app-pos-profile-edit',
  standalone: true,
  imports: [PosProfileFormWrapperComponent],
  templateUrl: './pos-profile-edit.component.html',
  styleUrls: ['./pos-profile-edit.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PosProfileEditComponent {
  private posProfileService = inject(PosProfileService);
  
  config: PosProfileFormConfig = {
    ...getPosProfileFormConfig(this.posProfileService),
    title: 'pos.form.edit_pos_terminal'
  };
}
